import React from 'react'
import useAutocomplete from '../../../hooks/useAutocomplete'
import { ApiConfig } from '../../../config/api'
import { TypePosition } from '../../../components/TypePosition/types/TypePosition'
import { AutoCompleter } from '../../../components/AutoCompleter/AutoCompleter'

interface TypePositionAutocompleteProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  positionValue: string
  typePositionNameList?: string
  variant?: 'outlined' | 'standard' | 'filled'
  fullWidth?: boolean
  size?: 'small' | 'medium'
}

const AUTOCOMPLETE_SETTINGS: Record<
  string,
  { label: string; dataKey: keyof TypePosition }
> = {
  typePositionCode: {
    label: 'Código Del Tipo de Posición',
    dataKey: 'typePositionCode'
  },
  typePositionDescription: {
    label: 'Descripción Del Tipo de Posición',
    dataKey: 'typePositionDescription'
  }
}

export const TypePositionAutocomplete: React.FC<
  TypePositionAutocompleteProps
> = ({
  handleChange,
  positionValue,
  typePositionNameList = 'typePositionCode',
  variant = 'standard',
  fullWidth = false,
  size = 'small'
}) => {
  const { data: typeposiciones, loader: loaderPosiciones } =
    useAutocomplete<TypePosition>(
      positionValue,
      `${ApiConfig.TypepositionApi}/GetByCodeOrDescription?typeposition=${positionValue}`,
      3
    )

  const currentSetting =
    AUTOCOMPLETE_SETTINGS[typePositionNameList] ||
    AUTOCOMPLETE_SETTINGS['typePositionCode']

  return (
    <AutoCompleter
      item={typeposiciones.map((item: TypePosition) => ({
        value: item[currentSetting.dataKey] as string | number
      }))}
      nameList={typePositionNameList}
      labelList={currentSetting.label}
      handleChange={handleChange}
      isLoader={loaderPosiciones}
      value={positionValue}
      variant={variant}
      fullWidth={fullWidth}
      size={size}
    />
  )
}
